import React, { useState } from 'react';

const deleteCompany = async (code) => {
  let wsUrl = `${import.meta.env.VITE_REACT_APP_BACK_NODE_COMPANY_ENDPOINT}/${code}`;

  try {
    const response = await fetch(wsUrl, {
      method: 'DELETE'
    });

    if (response.ok) {
      let text = await response.text();
      console.log("response data : " + text);
    } else {
      let text = await response.text();
      console.log("error response text : " + text);
    }

  } catch (ex) {
    console.log("ex : " + ex);
  }
};

const CompanyDelete = () => {
  const [companyCode, setCompanyCode] = useState('');

  const handleDelete = () => {
    deleteCompany(companyCode);
  };

  const handleCodeChange = (event) => {
    setCompanyCode(event.target.value);
  };

  return (
    <div>
      <input type="text" value={companyCode} onChange={handleCodeChange} placeholder="Company Code" />
      <button onClick={handleDelete}>Delete Company</button>
    </div>
  );
};

export default CompanyDelete;
